import React from "react";
import img1 from "../img/portfolio1.PNG";
import img2 from "../img/portfolio2.PNG";
import img3 from "../img/portfolio3.PNG";
import img4 from "../img/portfolio4.PNG";
import img5 from "../img/portfolio5.PNG";
import img6 from "../img/portfolio6.PNG";

function Projects() {
  const Projects = [
    {
      id: 1,
      img: img1,
      title: "Ecommerce Website",
      github: "https://github.com/ZakariaHizzi/react-ecommerce-website",
      live: "https://lustrous-mandazi-e1661c.netlify.app/",
    },
    {
      id: 2,
      img: img2,
      title: "traveling Website",
      github: "https://github.com/ZakariaHizzi/traveling-web-site",
      live: "https://iridescent-gumption-57f3f7.netlify.app/",
    },
    {
      id: 3,
      img: img3,
      title: "Estate Website",
      github: "https://github.com/ZakariaHizzi/estate-react-website",
      live: "https://moonlit-peony-df9f74.netlify.app/",
    },
    {
      id: 4,
      img: img4,
      title: "Restaurant Website",
      github: "https://github.com/ZakariaHizzi/restaurant-website",
      live: "https://verdant-capybara-5a4fb0.netlify.app/",
    },
    {
      id: 5,
      img: img5,
      title: "University Website",
      github: "https://github.com/ZakariaHizzi/university-web-site",
      live: "https://vermillion-panda-ab3774.netlify.app/",
    },
    {
      id: 6,
      img: img6,
      title: " Hospital Website",
      github: "https://github.com/ZakariaHizzi/doctor-website",
      live: "https://doctor-website-zkhz.vercel.app/",
    },
  ];
  return (
    <div id="projects">
      <section className="Projects">
        <div className="top_section">
          <h5>My recent Work</h5>
          <h2>Portfolio</h2>
        </div>
        <div className="container projects-container">
          {Projects.map((project) => (
            <article className="portfolio_item">
              <div className="portfolio_item_img">
                <img src={project.img} alt="" />
              </div>
              <h3>{project.title}</h3>
              <div className="portfolio_item_btn">
                <a className="btn" href={project.github} target="_blank">
                  Github
                </a>
                <a className="btn" href={project.live} target="_blank">
                  Live demo
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Projects;
